<script lang="tsx">
import { Component, DefineComponent, defineComponent, nextTick, PropType, reactive, ref, toRefs, Teleport } from 'vue';

export interface MenuNodeProps {
  onClose: () => void;
  menuInfo?: any;
}

const RightMenu = defineComponent({
  name: 'RightMenu',
  props: {
    MenuNode: {
      type: Object as PropType<Component>,
      required: true,
    },
    minWidth: {
      type: Number,
      default: 150,
    },
    zIndex: {
      type: Number,
      default: 2,
    },
    menuInfo: {
      type: Object,
    },
  },
  setup(props, ctx) {
    const MenuNode = props.MenuNode as DefineComponent<MenuNodeProps>;
    const rightMenuContext = ref();
    let _data = reactive({
      position: {
        x: 0,
        y: 0,
      },
      style: {
        zIndex: 2,
        minWidth: 150,
      },
      opacity: 0,
      mouseListening: false,
      menuShow: false,
    });
    const { position, opacity, style, menuShow } = toRefs(_data);
    const onClose = () => {
      _data.menuShow = false;
      _data.opacity = 0;
      _methods.removeListener();
    };

    const outSlideDestroy = (el: { parentElement: any; className: string | string[] }) => {
      let hasMean = false;
      while (el.parentElement && !hasMean) {
        if (el.className.indexOf('rightMenuContext') !== -1) {
          hasMean = true;
        } else {
          el = el.parentElement;
        }
      }
      if (!hasMean) {
        onClose();
      }
    };
    const _methods = {
      mouseDownListener(e: { target: any }) {
        let el = e.target;
        outSlideDestroy(el);
      },
      addListener() {
        if (!_data.mouseListening) {
          document.addEventListener('click', _methods.mouseDownListener);
          document.addEventListener('mousedown', _methods.mouseDownListener);
          _data.mouseListening = true;
        }
      },
      removeListener() {
        if (_data.mouseListening) {
          document.removeEventListener('click', _methods.mouseDownListener);
          document.removeEventListener('mousedown', _methods.mouseDownListener);
          _data.mouseListening = false;
        }
      },
    };
    const onOpenMenu = (event: MouseEvent) => {
      // 阻止默认事件和冒泡
      event.preventDefault();
      event.stopPropagation();
      _data.menuShow = true;
      _data.position.x = event.clientX;
      _data.position.y = event.clientY;
      console.log("🚀 ~ onOpenMenu ~ _data.position:", _data.position)
      _data.style.zIndex = props.zIndex;
      _data.style.minWidth = props.minWidth;
      nextTick(() => {
        let domWidth = rightMenuContext.value.clientWidth,
          domHeight = rightMenuContext.value.clientHeight;
        let height = document.body.clientHeight,
          width = document.body.clientWidth;
        if (event.clientY + domHeight > height) {
          _data.position.y = _data.position.y - domHeight;
        }
        if (event.clientX + domWidth > width) {
          _data.position.x = _data.position.x - domWidth;
        }
        _data.opacity = 1;
        _methods.addListener();
      });
    };
    return () => (
      <>
        <Teleport to="body">
          {menuShow.value && (
            <div
              class='rightMenuContext'
              ref={rightMenuContext}
              style={{
                position: 'fixed',
                left: position.value.x + 'px',
                top: position.value.y + 'px',
                minWidth: style.value.minWidth + 'px',
                'z-index': style.value.zIndex,
                opacity: opacity.value,
              }}
            >
              <MenuNode onClose={onClose} menuInfo={props.menuInfo} />
            </div>
          )}
        </Teleport>
        <span class={``} onContextmenu={onOpenMenu}>
          {ctx.slots.default?.()}
        </span>
      </>
    );
  },
});

export default RightMenu;
</script>

<style></style>
